import {JSONable} from "@irian-ro/abstract-resource";
import { GlobalAccountVoModel } from '../crm/global-account-vo.model';
import { TerritoryVO } from '../crm/territory-vo.model';
import {FormControl, FormGroup} from "@angular/forms";

export class CustomerDetailsDTO extends JSONable {

  uuid: string | undefined = undefined;
  customerTerritoryVO: TerritoryVO | undefined = undefined;
  globalAccountDTO: GlobalAccountVoModel | undefined = undefined;
  favourite: boolean | undefined = undefined;

  static createForm(): FormGroup {
    return  new FormGroup({
      uuid: new FormControl(null),
      customerTerritoryVO: new FormControl(null),
      globalAccountDTO: new FormControl(null),
      favourite: new FormControl(null)
    });
  }
}
